import { render } from "./NavHeader.vue?vue&type=template&id=10f60c04"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=10f60c04&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__